/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrivateBankingServiceDefinitionId } from './PrivateBankingServiceDefinitionId';
import {
    PrivateBankingServiceDefinitionIdFromJSON,
    PrivateBankingServiceDefinitionIdFromJSONTyped,
    PrivateBankingServiceDefinitionIdToJSON,
    PrivateBankingServiceDefinitionIdToJSONTyped,
} from './PrivateBankingServiceDefinitionId';
import type { ProductRelation } from './ProductRelation';
import {
    ProductRelationFromJSON,
    ProductRelationFromJSONTyped,
    ProductRelationToJSON,
    ProductRelationToJSONTyped,
} from './ProductRelation';
import type { ProductConflict } from './ProductConflict';
import {
    ProductConflictFromJSON,
    ProductConflictFromJSONTyped,
    ProductConflictToJSON,
    ProductConflictToJSONTyped,
} from './ProductConflict';

/**
 * Representation of product to show to the user
 * @export
 * @interface PrivateBankingProductCatalogueResponse
 */
export interface PrivateBankingProductCatalogueResponse {
    /**
     * 
     * @type {string}
     * @memberof PrivateBankingProductCatalogueResponse
     */
    uid?: string;
    /**
     * 
     * @type {PrivateBankingServiceDefinitionId}
     * @memberof PrivateBankingProductCatalogueResponse
     */
    productId?: PrivateBankingServiceDefinitionId;
    /**
     * ServiceDefinitionV2.serviceDefinitionName
     * @type {string}
     * @memberof PrivateBankingProductCatalogueResponse
     */
    productName?: string;
    /**
     * ServiceDefinitionV2.shortDescription
     * @type {string}
     * @memberof PrivateBankingProductCatalogueResponse
     */
    shortDescription?: string;
    /**
     * Defines if service definition can be added to the br based on eligibility
     * @type {boolean}
     * @memberof PrivateBankingProductCatalogueResponse
     */
    canBeAdded?: boolean;
    /**
     * Maximum number of agreements of this service definition that may be opened on a business relation. null or -1 means unlimited. 0 means that even a single service agreement can't be created . Maps to ServiceDefinitionV2.maxNo.
     * @type {number}
     * @memberof PrivateBankingProductCatalogueResponse
     */
    maxInstances?: number;
    /**
     * True when the number of existing blocking agreements for this service definition on the BR has reached maxInstances (also true when maxInstances is 0). When true the product cannot be added again. Computed from ServiceDefinitionV2.isMaxNoReached.
     * @type {boolean}
     * @memberof PrivateBankingProductCatalogueResponse
     */
    maxInstancesReached?: boolean;
    /**
     * Products that prevent this product from being added. Unlike canBeAdded this does not grey the product out: the user can still select it and is then told why it cannot be added. The list is the same for every business relation. An entry applies when the conflicting product is already on the business relation, or is requested together with this one.
     * @type {Array<ProductConflict>}
     * @memberof PrivateBankingProductCatalogueResponse
     */
    conflictsWith?: Array<ProductConflict>;
    /**
     * Sub-definitions which belong to this definition
     * @type {Array<ProductRelation>}
     * @memberof PrivateBankingProductCatalogueResponse
     */
    children?: Array<ProductRelation>;
}



/**
 * Check if a given object implements the PrivateBankingProductCatalogueResponse interface.
 */
export function instanceOfPrivateBankingProductCatalogueResponse(value: object): value is PrivateBankingProductCatalogueResponse {
    return true;
}

export function PrivateBankingProductCatalogueResponseFromJSON(json: any): PrivateBankingProductCatalogueResponse {
    return PrivateBankingProductCatalogueResponseFromJSONTyped(json, false);
}

export function PrivateBankingProductCatalogueResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrivateBankingProductCatalogueResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'uid': json['uid'] == null ? undefined : json['uid'],
        'productId': json['productId'] == null ? undefined : PrivateBankingServiceDefinitionIdFromJSON(json['productId']),
        'productName': json['productName'] == null ? undefined : json['productName'],
        'shortDescription': json['shortDescription'] == null ? undefined : json['shortDescription'],
        'canBeAdded': json['canBeAdded'] == null ? undefined : json['canBeAdded'],
        'maxInstances': json['maxInstances'] == null ? undefined : json['maxInstances'],
        'maxInstancesReached': json['maxInstancesReached'] == null ? undefined : json['maxInstancesReached'],
        'conflictsWith': json['conflictsWith'] == null ? undefined : ((json['conflictsWith'] as Array<any>).map(ProductConflictFromJSON)),
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(ProductRelationFromJSON)),
    };
}

export function PrivateBankingProductCatalogueResponseToJSON(json: any): PrivateBankingProductCatalogueResponse {
    return PrivateBankingProductCatalogueResponseToJSONTyped(json, false);
}

export function PrivateBankingProductCatalogueResponseToJSONTyped(value?: PrivateBankingProductCatalogueResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uid': value['uid'],
        'productId': PrivateBankingServiceDefinitionIdToJSON(value['productId']),
        'productName': value['productName'],
        'shortDescription': value['shortDescription'],
        'canBeAdded': value['canBeAdded'],
        'maxInstances': value['maxInstances'],
        'maxInstancesReached': value['maxInstancesReached'],
        'conflictsWith': value['conflictsWith'] == null ? undefined : ((value['conflictsWith'] as Array<any>).map(ProductConflictToJSON)),
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(ProductRelationToJSON)),
    };
}

